import { Card, Row, Col, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const StatCard = ({ title, value, icon, link }) => {
    const navigate = useNavigate();
    const handleNavigate = (e) => {
        e.preventDefault();
        const relativeLink = link.replace(process.env.REACT_APP_URL || "", "");
        navigate(relativeLink);
    };

    return (
    <Card
        bordered={false}
        style={{
            height: "100%",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            cursor: "pointer",
        }}
    >
        <Row align="middle" justify="space-between">
            {/* Left side: icon + text */}
            <Col>
                <Row align="middle" gutter={16}>
                    <Col style={{ fontSize: "50px", color: "#1890ff" }}>{icon}</Col>
                    <Col>
                        <Title level={5} style={{ margin: 0 }}>
                            {title}
                        </Title>
                        <p style={{ fontSize: "26px", fontWeight: "bold", margin: 0 }}>
                            {value}
                        </p>
                    </Col>
                </Row>
            </Col>

            {/* Right side: arrow */}
            {(link) && (
                <Col>
                    <a
                        href={link}
                        onClick={handleNavigate}
                        rel="noopener noreferrer"
                        style={{
                            fontSize: "35px",
                            color: "#1890ff",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <ArrowRightOutlined />
                    </a>
                </Col>
            )}
        </Row>
    </Card>
    );
};

export default StatCard;